import { createFileRoute } from '@tanstack/react-router'
import { KnowledgeBasePage } from '@/features/incidents/knowledge-base'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/knowledge-base'
)({
  component: KnowledgeBasePage,
})

